export enum AccountFormMode {
    CreateNewAccount = 'createNewAccount',
    EditAccount = 'editAccount'
}
